__turbopack_context__.v({
  "button": "emailCapture-module-scss-module__cZUeSq__button",
  "emailCapture": "emailCapture-module-scss-module__cZUeSq__emailCapture",
  "emailForm": "emailCapture-module-scss-module__cZUeSq__emailForm",
  "emailInput": "emailCapture-module-scss-module__cZUeSq__emailInput",
  "formElements": "emailCapture-module-scss-module__cZUeSq__formElements",
  "iconSend": "emailCapture-module-scss-module__cZUeSq__iconSend",
  "mailInputError": "emailCapture-module-scss-module__cZUeSq__mailInputError",
  "mailInputSuccess": "emailCapture-module-scss-module__cZUeSq__mailInputSuccess",
  "spinnerContainer": "emailCapture-module-scss-module__cZUeSq__spinnerContainer",
  "successCheck": "emailCapture-module-scss-module__cZUeSq__successCheck",
  "textAlignLeft": "emailCapture-module-scss-module__cZUeSq__textAlignLeft",
});
